// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__18syw","slick-next":"CustomSlider_slick-next__IXoL6"};